<div class="section-details">
    <div class="section-header">
        <div class="section-title-container">
            <div class="section-title">
                {{ "assetmanagement.edit-ownership-information.title" | transloco }}
            </div>
            <cerrix-instructions-icon
                [instructionText]="
                    'assetmanagement.edit-ownership-information.instructionText' | transloco
                "
                [showText]="false"
            ></cerrix-instructions-icon>
        </div>
        <div class="section-subtitle">
            {{ "assetmanagement.edit-ownership-information.subTitle" | transloco }}
        </div>
    </div>
    @if (editModel) {
        <div class="section-fields">
            <app-cerrix-tree-item-picker-single
                name="asset-organization-owner"
                appValidationRequired
                [items]="organizationsList"
                [selectedValue]="editModel.owningOrganizationId"
                [label]="'assetmanagement.detail.organizationOwnerLabel' | transloco"
                [placeholder]="
                    'assetmanagement.edit-ownership-information.organizationPlaceholder' | transloco
                "
                [dialogTitle]="
                    'assetmanagement.edit-ownership-information.organizationDialogTitle' | transloco
                "
                [infoText]="
                    'assetmanagement.edit-ownership-information.organizationOwnerInfo' | transloco
                "
                iconPrefix="third-party"
                defaultIcon="third-party"
                (valueChanged)="editModel.owningOrganizationId = $event"
            ></app-cerrix-tree-item-picker-single>
            <app-cerrix-user-picker
                name="asset-owner"
                [users]="userList"
                [(value)]="editModel.ownerId"
                [label]="'assetmanagement.edit-ownership-information.ownerLabel' | transloco"
                [infoText]="'assetmanagement.edit-ownership-information.ownerInfo' | transloco"
            ></app-cerrix-user-picker>
        </div>
    }
</div>
<div class="slide-out-footer">
    <cerrix-button
        buttonType="secondary"
        buttonSize="big"
        secondaryColor="filled"
        data-uiid="asset-management-edit-cancel"
        (click)="openUnsavedChangesConfirmDialog()"
    >
        {{ "assetmanagement.detail.cancelButton" | transloco }}
    </cerrix-button>
    <cerrix-button
        buttonType="primary"
        buttonSize="big"
        data-uiid="asset-management-edit-save-section"
        [disabled]="editSaving"
        (click)="editSave()"
    >
        {{ "assetmanagement.detail.editSaveButton" | transloco }}
    </cerrix-button>
</div>

<cerrix-confirm-dialog
    [name]="confirmUnsavedChangesDialogName"
    dataUiid="asset-management-edit-unsaved-changes-confirm"
    icon="warning"
    [title]="'assetmanagement.edit-ownership-information.unsavedChangesDialogTitle' | transloco"
    [description]="
        'assetmanagement.edit-ownership-information.unsavedChangesDialogDescription' | transloco
    "
    [cancelText]="
        'assetmanagement.edit-ownership-information.unsavedChangesDialogCancelText' | transloco
    "
    [confirmText]="
        'assetmanagement.edit-ownership-information.unsavedChangesDialogConfirmText' | transloco
    "
    (cancel)="editCancel()"
    (confirm)="editSave()"
    [waitingOnResult]="editSaving"
    [showResultText]="editSaving"
    class="dialog-unsaved-changes-confirm"
>
</cerrix-confirm-dialog>
